/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
export var acceptLanguage0 = {
    parameterPath: "acceptLanguage",
    mapper: {
        required: true,
        serializedName: "Accept-Language",
        type: {
            name: "String"
        }
    }
};
export var acceptLanguage1 = {
    parameterPath: [
        "options",
        "acceptLanguage"
    ],
    mapper: {
        serializedName: "Accept-Language",
        type: {
            name: "String"
        }
    }
};
export var addressId0 = {
    parameterPath: "addressId",
    mapper: {
        required: true,
        serializedName: "addressId",
        type: {
            name: "String"
        }
    }
};
export var addressId1 = {
    parameterPath: "addressId",
    mapper: {
        required: true,
        serializedName: "addressId",
        type: {
            name: "Number"
        }
    }
};
export var addressId2 = {
    parameterPath: [
        "options",
        "addressId"
    ],
    mapper: {
        serializedName: "addressId",
        type: {
            name: "Number"
        }
    }
};
export var applicationKey = {
    parameterPath: "applicationKey",
    mapper: {
        required: true,
        serializedName: "applicationKey",
        type: {
            name: "String"
        }
    }
};
export var approvalStates = {
    parameterPath: [
        "options",
        "approvalStates"
    ],
    mapper: {
        serializedName: "approvalStates",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var area0 = {
    parameterPath: [
        "options",
        "area"
    ],
    mapper: {
        serializedName: "area",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var area1 = {
    parameterPath: [
        "options",
        "area"
    ],
    mapper: {
        serializedName: "Area",
        type: {
            name: "String"
        }
    }
};
export var atpClusterId = {
    parameterPath: "atpClusterId",
    mapper: {
        required: true,
        serializedName: "atpClusterId",
        type: {
            name: "Number"
        }
    }
};
export var bagItemId = {
    parameterPath: "bagItemId",
    mapper: {
        required: true,
        serializedName: "bagItemId",
        type: {
            name: "Number"
        }
    }
};
export var bankAccountId0 = {
    parameterPath: "bankAccountId",
    mapper: {
        required: true,
        serializedName: "bankAccountId",
        type: {
            name: "String"
        }
    }
};
export var bankAccountId1 = {
    parameterPath: "bankAccountId",
    mapper: {
        required: true,
        serializedName: "bankAccountId",
        type: {
            name: "Number"
        }
    }
};
export var bankBranchId = {
    parameterPath: "bankBranchId",
    mapper: {
        required: true,
        serializedName: "bankBranchId",
        type: {
            name: "Number"
        }
    }
};
export var bankBranchIds = {
    parameterPath: [
        "options",
        "bankBranchIds"
    ],
    mapper: {
        serializedName: "bankBranchIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Number"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var bankId0 = {
    parameterPath: [
        "options",
        "bankId"
    ],
    mapper: {
        serializedName: "bankId",
        type: {
            name: "Number"
        }
    }
};
export var bankId1 = {
    parameterPath: "bankId",
    mapper: {
        required: true,
        serializedName: "bankId",
        type: {
            name: "Number"
        }
    }
};
export var bankIds = {
    parameterPath: [
        "options",
        "bankIds"
    ],
    mapper: {
        serializedName: "bankIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Number"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var blockingCodeIds = {
    parameterPath: [
        "options",
        "blockingCodeIds"
    ],
    mapper: {
        serializedName: "blockingCodeIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Number"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var blockingState = {
    parameterPath: [
        "options",
        "blockingState"
    ],
    mapper: {
        serializedName: "blockingState",
        type: {
            name: "String"
        }
    }
};
export var blockingType = {
    parameterPath: [
        "options",
        "blockingType"
    ],
    mapper: {
        serializedName: "blockingType",
        type: {
            name: "String"
        }
    }
};
export var campaignId = {
    parameterPath: "campaignId",
    mapper: {
        required: true,
        serializedName: "campaignId",
        type: {
            name: "Number"
        }
    }
};
export var campaignType0 = {
    parameterPath: [
        "options",
        "campaignType"
    ],
    mapper: {
        serializedName: "campaignType",
        type: {
            name: "String"
        }
    }
};
export var campaignType1 = {
    parameterPath: "campaignType",
    mapper: {
        required: true,
        serializedName: "campaignType",
        type: {
            name: "String"
        }
    }
};
export var catalogueCode = {
    parameterPath: "catalogueCode",
    mapper: {
        required: true,
        serializedName: "catalogueCode",
        type: {
            name: "String"
        }
    }
};
export var catalogueCode1 = {
    parameterPath: "catalogueCode1",
    mapper: {
        required: true,
        serializedName: "catalogueCode",
        type: {
            name: "String"
        }
    }
};
export var catalogueId = {
    parameterPath: "catalogueId",
    mapper: {
        required: true,
        serializedName: "catalogueId",
        type: {
            name: "Number"
        }
    }
};
export var catalogueItemId = {
    parameterPath: "catalogueItemId",
    mapper: {
        required: true,
        serializedName: "catalogueItemId",
        type: {
            name: "String"
        }
    }
};
export var categoryId0 = {
    parameterPath: [
        "options",
        "categoryId"
    ],
    mapper: {
        serializedName: "categoryId",
        type: {
            name: "String"
        }
    }
};
export var categoryId1 = {
    parameterPath: "categoryId",
    mapper: {
        required: true,
        serializedName: "categoryId",
        type: {
            name: "Uuid"
        }
    }
};
export var categoryId2 = {
    parameterPath: "categoryId",
    mapper: {
        required: true,
        serializedName: "categoryId",
        type: {
            name: "String"
        }
    }
};
export var channels = {
    parameterPath: [
        "options",
        "channels"
    ],
    mapper: {
        serializedName: "channels",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var choiceId = {
    parameterPath: "choiceId",
    mapper: {
        required: true,
        serializedName: "choiceId",
        type: {
            name: "Number"
        }
    }
};
export var city0 = {
    parameterPath: [
        "options",
        "city"
    ],
    mapper: {
        serializedName: "city",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var city1 = {
    parameterPath: [
        "options",
        "city"
    ],
    mapper: {
        serializedName: "City",
        type: {
            name: "String"
        }
    }
};
export var code = {
    parameterPath: [
        "options",
        "code"
    ],
    mapper: {
        serializedName: "code",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var conceptCode = {
    parameterPath: "conceptCode",
    mapper: {
        required: true,
        serializedName: "conceptCode",
        type: {
            name: "String"
        }
    }
};
export var conceptCodes = {
    parameterPath: "conceptCodes",
    mapper: {
        required: true,
        serializedName: "conceptCodes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var consultantNumber = {
    parameterPath: "consultantNumber",
    mapper: {
        required: true,
        serializedName: "consultantNumber",
        type: {
            name: "Number"
        }
    }
};
export var contactId = {
    parameterPath: "contactId",
    mapper: {
        required: true,
        serializedName: "contactId",
        type: {
            name: "Number"
        }
    }
};
export var country0 = {
    parameterPath: [
        "options",
        "country"
    ],
    mapper: {
        serializedName: "country",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var country1 = {
    parameterPath: [
        "options",
        "country"
    ],
    mapper: {
        serializedName: "Country",
        type: {
            name: "String"
        }
    }
};
export var country2 = {
    parameterPath: [
        "options",
        "country"
    ],
    mapper: {
        serializedName: "country",
        type: {
            name: "String"
        }
    }
};
export var courierId = {
    parameterPath: "courierId",
    mapper: {
        required: true,
        serializedName: "courierId",
        type: {
            name: "String"
        }
    }
};
export var customerAttributeTypeId0 = {
    parameterPath: "customerAttributeTypeId",
    mapper: {
        required: true,
        serializedName: "customerAttributeTypeId",
        type: {
            name: "Number"
        }
    }
};
export var customerAttributeTypeId1 = {
    parameterPath: "customerAttributeTypeId",
    mapper: {
        required: true,
        serializedName: "customerAttributeTypeId",
        type: {
            name: "String"
        }
    }
};
export var customerId0 = {
    parameterPath: "customerId",
    mapper: {
        required: true,
        serializedName: "customerId",
        type: {
            name: "Number"
        }
    }
};
export var customerId1 = {
    parameterPath: [
        "options",
        "customerId"
    ],
    mapper: {
        serializedName: "customerId",
        type: {
            name: "Number"
        }
    }
};
export var customerId2 = {
    parameterPath: "customerId",
    mapper: {
        required: true,
        serializedName: "customerId",
        type: {
            name: "String"
        }
    }
};
export var customerId3 = {
    parameterPath: [
        "options",
        "customerId"
    ],
    mapper: {
        serializedName: "customerId",
        defaultValue: 0,
        type: {
            name: "Number"
        }
    }
};
export var deliveryAddressId = {
    parameterPath: "deliveryAddressId",
    mapper: {
        required: true,
        serializedName: "deliveryAddressId",
        type: {
            name: "Number"
        }
    }
};
export var deliveryChannelId0 = {
    parameterPath: [
        "options",
        "deliveryChannelId"
    ],
    mapper: {
        serializedName: "deliveryChannelId",
        type: {
            name: "Number"
        }
    }
};
export var deliveryChannelId1 = {
    parameterPath: "deliveryChannelId",
    mapper: {
        required: true,
        serializedName: "deliveryChannelId",
        type: {
            name: "Number"
        }
    }
};
export var deviceToken = {
    parameterPath: "deviceToken",
    mapper: {
        required: true,
        serializedName: "deviceToken",
        type: {
            name: "String"
        }
    }
};
export var district0 = {
    parameterPath: [
        "options",
        "district"
    ],
    mapper: {
        serializedName: "district",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var district1 = {
    parameterPath: [
        "options",
        "district"
    ],
    mapper: {
        serializedName: "District",
        type: {
            name: "String"
        }
    }
};
export var documentApprovalId = {
    parameterPath: "documentApprovalId",
    mapper: {
        required: true,
        serializedName: "documentApprovalId",
        type: {
            name: "Number"
        }
    }
};
export var documentId = {
    parameterPath: "documentId",
    mapper: {
        required: true,
        serializedName: "documentId",
        type: {
            name: "Number"
        }
    }
};
export var documentIds = {
    parameterPath: [
        "options",
        "documentIds"
    ],
    mapper: {
        serializedName: "documentIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Number"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var documentTypeId = {
    parameterPath: [
        "options",
        "documentTypeId"
    ],
    mapper: {
        serializedName: "documentTypeId",
        type: {
            name: "Number"
        }
    }
};
export var dueDate = {
    parameterPath: [
        "options",
        "dueDate"
    ],
    mapper: {
        serializedName: "dueDate",
        type: {
            name: "DateTime"
        }
    }
};
export var emailAddress = {
    parameterPath: "emailAddress",
    mapper: {
        required: true,
        serializedName: "emailAddress",
        type: {
            name: "String"
        }
    }
};
export var endConsumerId = {
    parameterPath: "endConsumerId",
    mapper: {
        required: true,
        serializedName: "endConsumerId",
        type: {
            name: "Number"
        }
    }
};
export var externalProvider = {
    parameterPath: "externalProvider",
    mapper: {
        required: true,
        serializedName: "externalProvider",
        type: {
            name: "String"
        }
    }
};
export var file = {
    parameterPath: [
        "options",
        "file"
    ],
    mapper: {
        serializedName: "file",
        type: {
            name: "Stream"
        }
    }
};
export var frontPageBannerId = {
    parameterPath: "frontPageBannerId",
    mapper: {
        required: true,
        serializedName: "frontPageBannerId",
        type: {
            name: "String"
        }
    }
};
export var height = {
    parameterPath: [
        "options",
        "height"
    ],
    mapper: {
        serializedName: "height",
        type: {
            name: "Number"
        }
    }
};
export var ids = {
    parameterPath: "ids",
    mapper: {
        required: true,
        serializedName: "ids",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var imageInfoId = {
    parameterPath: "imageInfoId",
    mapper: {
        required: true,
        serializedName: "imageInfoId",
        type: {
            name: "Uuid"
        }
    }
};
export var includedProducts = {
    parameterPath: [
        "options",
        "includedProducts"
    ],
    mapper: {
        serializedName: "includedProducts",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var ingredientCode = {
    parameterPath: "ingredientCode",
    mapper: {
        required: true,
        serializedName: "ingredientCode",
        type: {
            name: "String"
        }
    }
};
export var ingredientCodes = {
    parameterPath: [
        "options",
        "ingredientCodes"
    ],
    mapper: {
        serializedName: "ingredientCodes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var installationId = {
    parameterPath: "installationId",
    mapper: {
        required: true,
        serializedName: "installationId",
        type: {
            name: "String"
        }
    }
};
export var isBlocked = {
    parameterPath: [
        "options",
        "isBlocked"
    ],
    mapper: {
        serializedName: "isBlocked",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var isStandardItem = {
    parameterPath: [
        "options",
        "isStandardItem"
    ],
    mapper: {
        serializedName: "isStandardItem",
        type: {
            name: "Boolean"
        }
    }
};
export var isTemporary = {
    parameterPath: [
        "options",
        "isTemporary"
    ],
    mapper: {
        serializedName: "isTemporary",
        defaultValue: true,
        type: {
            name: "Boolean"
        }
    }
};
export var itemCode0 = {
    parameterPath: "itemCode",
    mapper: {
        required: true,
        serializedName: "itemCode",
        type: {
            name: "String"
        }
    }
};
export var itemCode1 = {
    parameterPath: [
        "options",
        "itemCode"
    ],
    mapper: {
        serializedName: "itemCode",
        type: {
            name: "String"
        }
    }
};
export var itemCodes = {
    parameterPath: [
        "options",
        "itemCodes"
    ],
    mapper: {
        serializedName: "itemCodes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var listId = {
    parameterPath: "listId",
    mapper: {
        required: true,
        serializedName: "listId",
        type: {
            name: "Number"
        }
    }
};
export var locality0 = {
    parameterPath: [
        "options",
        "locality"
    ],
    mapper: {
        serializedName: "locality",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var locality1 = {
    parameterPath: [
        "options",
        "locality"
    ],
    mapper: {
        serializedName: "Locality",
        type: {
            name: "String"
        }
    }
};
export var loginString = {
    parameterPath: "loginString",
    mapper: {
        required: true,
        serializedName: "loginString",
        type: {
            name: "String"
        }
    }
};
export var market = {
    parameterPath: [
        "options",
        "market"
    ],
    mapper: {
        serializedName: "market",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var messageType = {
    parameterPath: [
        "options",
        "messageType"
    ],
    mapper: {
        serializedName: "messageType",
        type: {
            name: "Number"
        }
    }
};
export var method = {
    parameterPath: [
        "options",
        "method"
    ],
    mapper: {
        serializedName: "method",
        type: {
            name: "String"
        }
    }
};
export var name = {
    parameterPath: [
        "options",
        "name"
    ],
    mapper: {
        serializedName: "name",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var navigationType = {
    parameterPath: "navigationType",
    mapper: {
        required: true,
        serializedName: "navigationType",
        type: {
            name: "String"
        }
    }
};
export var nodeId = {
    parameterPath: "nodeId",
    mapper: {
        required: true,
        serializedName: "nodeId",
        type: {
            name: "String"
        }
    }
};
export var notificationId = {
    parameterPath: "notificationId",
    mapper: {
        required: true,
        serializedName: "notificationId",
        type: {
            name: "String"
        }
    }
};
export var notificationType = {
    parameterPath: [
        "options",
        "notificationType"
    ],
    mapper: {
        serializedName: "notificationType",
        type: {
            name: "String"
        }
    }
};
export var offerId0 = {
    parameterPath: "offerId",
    mapper: {
        required: true,
        serializedName: "offerId",
        type: {
            name: "Number"
        }
    }
};
export var offerId1 = {
    parameterPath: "offerId",
    mapper: {
        required: true,
        serializedName: "offerId",
        type: {
            name: "String"
        }
    }
};
export var offsets = {
    parameterPath: "offsets",
    mapper: {
        required: true,
        serializedName: "offsets",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Number"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var onlyActive = {
    parameterPath: [
        "options",
        "onlyActive"
    ],
    mapper: {
        serializedName: "onlyActive",
        type: {
            name: "Boolean"
        }
    }
};
export var orderId = {
    parameterPath: "orderId",
    mapper: {
        required: true,
        serializedName: "orderId",
        type: {
            name: "Number"
        }
    }
};
export var orderOriginType = {
    parameterPath: [
        "options",
        "orderOriginType"
    ],
    mapper: {
        serializedName: "orderOriginType",
        type: {
            name: "String"
        }
    }
};
export var orderType = {
    parameterPath: [
        "options",
        "orderType"
    ],
    mapper: {
        serializedName: "orderType",
        defaultValue: 'Normal',
        type: {
            name: "String"
        }
    }
};
export var pathKey = {
    parameterPath: [
        "options",
        "pathKey"
    ],
    mapper: {
        serializedName: "PathKey",
        type: {
            name: "String"
        }
    }
};
export var paymentProviderId = {
    parameterPath: "paymentProviderId",
    mapper: {
        required: true,
        serializedName: "paymentProviderId",
        type: {
            name: "Number"
        }
    }
};
export var periodCode = {
    parameterPath: "periodCode",
    mapper: {
        required: true,
        serializedName: "periodCode",
        type: {
            name: "Number"
        }
    }
};
export var periodId = {
    parameterPath: [
        "options",
        "periodId"
    ],
    mapper: {
        serializedName: "periodId",
        type: {
            name: "Number"
        }
    }
};
export var potentialQualification = {
    parameterPath: [
        "options",
        "potentialQualification"
    ],
    mapper: {
        serializedName: "potentialQualification",
        defaultValue: true,
        type: {
            name: "Boolean"
        }
    }
};
export var product = {
    parameterPath: [
        "options",
        "product"
    ],
    mapper: {
        serializedName: "product",
        type: {
            name: "String"
        }
    }
};
export var productCode = {
    parameterPath: "productCode",
    mapper: {
        required: true,
        serializedName: "productCode",
        type: {
            name: "String"
        }
    }
};
export var productCodes0 = {
    parameterPath: [
        "options",
        "productCodes"
    ],
    mapper: {
        serializedName: "productCodes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var productCodes1 = {
    parameterPath: "productCodes",
    mapper: {
        required: true,
        serializedName: "productCodes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var productListId = {
    parameterPath: "productListId",
    mapper: {
        required: true,
        serializedName: "productListId",
        type: {
            name: "String"
        }
    }
};
export var productListingPageId = {
    parameterPath: "productListingPageId",
    mapper: {
        required: true,
        serializedName: "productListingPageId",
        type: {
            name: "String"
        }
    }
};
export var productListType = {
    parameterPath: "productListType",
    mapper: {
        required: true,
        serializedName: "productListType",
        type: {
            name: "String"
        }
    }
};
export var products = {
    parameterPath: [
        "options",
        "products"
    ],
    mapper: {
        serializedName: "products",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var promotionId = {
    parameterPath: "promotionId",
    mapper: {
        required: true,
        serializedName: "promotionId",
        type: {
            name: "Number"
        }
    }
};
export var province0 = {
    parameterPath: [
        "options",
        "province"
    ],
    mapper: {
        serializedName: "province",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var province1 = {
    parameterPath: [
        "options",
        "province"
    ],
    mapper: {
        serializedName: "Province",
        type: {
            name: "String"
        }
    }
};
export var query = {
    parameterPath: [
        "options",
        "query"
    ],
    mapper: {
        serializedName: "query",
        type: {
            name: "String"
        }
    }
};
export var region0 = {
    parameterPath: [
        "options",
        "region"
    ],
    mapper: {
        serializedName: "region",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var region1 = {
    parameterPath: [
        "options",
        "region"
    ],
    mapper: {
        serializedName: "Region",
        type: {
            name: "String"
        }
    }
};
export var registrationId = {
    parameterPath: "registrationId",
    mapper: {
        required: true,
        serializedName: "registrationId",
        type: {
            name: "String"
        }
    }
};
export var registrationType = {
    parameterPath: "registrationType",
    mapper: {
        required: true,
        serializedName: "registrationType",
        type: {
            name: "String"
        }
    }
};
export var relatedCategory = {
    parameterPath: "relatedCategory",
    mapper: {
        required: true,
        serializedName: "relatedCategory",
        type: {
            name: "String"
        }
    }
};
export var relationTypes = {
    parameterPath: [
        "options",
        "relationTypes"
    ],
    mapper: {
        serializedName: "relationTypes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var rootLevelOnly = {
    parameterPath: [
        "options",
        "rootLevelOnly"
    ],
    mapper: {
        serializedName: "rootLevelOnly",
        defaultValue: true,
        type: {
            name: "Boolean"
        }
    }
};
export var search = {
    parameterPath: [
        "options",
        "search"
    ],
    mapper: {
        serializedName: "search",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var searchTerm = {
    parameterPath: [
        "options",
        "searchTerm"
    ],
    mapper: {
        serializedName: "searchTerm",
        type: {
            name: "String"
        }
    }
};
export var searchText = {
    parameterPath: [
        "options",
        "searchText"
    ],
    mapper: {
        serializedName: "SearchText",
        type: {
            name: "String"
        }
    }
};
export var sectionId = {
    parameterPath: "sectionId",
    mapper: {
        required: true,
        serializedName: "sectionId",
        type: {
            name: "Number"
        }
    }
};
export var sessionId = {
    parameterPath: "sessionId",
    mapper: {
        required: true,
        serializedName: "sessionId",
        type: {
            name: "String"
        }
    }
};
export var settingId = {
    parameterPath: "settingId",
    mapper: {
        required: true,
        serializedName: "settingId",
        type: {
            name: "String"
        }
    }
};
export var settingsClient = {
    parameterPath: "settingsClient",
    mapper: {
        required: true,
        isConstant: true,
        serializedName: "settingsClient",
        defaultValue: 'OnlineReportingGrid',
        type: {
            name: "String"
        }
    }
};
export var since = {
    parameterPath: [
        "options",
        "since"
    ],
    mapper: {
        serializedName: "since",
        type: {
            name: "DateTime"
        }
    }
};
export var skip0 = {
    parameterPath: [
        "options",
        "skip"
    ],
    mapper: {
        serializedName: "skip",
        defaultValue: 0,
        type: {
            name: "Number"
        }
    }
};
export var skip1 = {
    parameterPath: [
        "options",
        "skip"
    ],
    mapper: {
        serializedName: "skip",
        type: {
            name: "Number"
        }
    }
};
export var skip2 = {
    parameterPath: [
        "options",
        "skip"
    ],
    mapper: {
        serializedName: "Skip",
        type: {
            name: "Number"
        }
    }
};
export var socialAction = {
    parameterPath: [
        "options",
        "socialAction"
    ],
    mapper: {
        serializedName: "socialAction",
        type: {
            name: "String"
        }
    }
};
export var socialEntityId = {
    parameterPath: "socialEntityId",
    mapper: {
        required: true,
        serializedName: "socialEntityId",
        type: {
            name: "String"
        }
    }
};
export var socialEntityType = {
    parameterPath: "socialEntityType",
    mapper: {
        required: true,
        serializedName: "socialEntityType",
        type: {
            name: "String"
        }
    }
};
export var sortBy = {
    parameterPath: [
        "options",
        "sortBy"
    ],
    mapper: {
        serializedName: "sortBy",
        defaultValue: 'Favorite',
        type: {
            name: "String"
        }
    }
};
export var sortType = {
    parameterPath: [
        "options",
        "sortType"
    ],
    mapper: {
        serializedName: "sortType",
        defaultValue: 'Ascending',
        type: {
            name: "String"
        }
    }
};
export var street0 = {
    parameterPath: [
        "options",
        "street"
    ],
    mapper: {
        serializedName: "street",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var street1 = {
    parameterPath: [
        "options",
        "street"
    ],
    mapper: {
        serializedName: "Street",
        type: {
            name: "String"
        }
    }
};
export var take0 = {
    parameterPath: [
        "options",
        "take"
    ],
    mapper: {
        serializedName: "take",
        defaultValue: 50,
        type: {
            name: "Number"
        }
    }
};
export var take1 = {
    parameterPath: [
        "options",
        "take"
    ],
    mapper: {
        serializedName: "take",
        defaultValue: 100,
        type: {
            name: "Number"
        }
    }
};
export var take2 = {
    parameterPath: [
        "options",
        "take"
    ],
    mapper: {
        serializedName: "take",
        defaultValue: 12,
        type: {
            name: "Number"
        }
    }
};
export var taskId = {
    parameterPath: "taskId",
    mapper: {
        required: true,
        serializedName: "taskId",
        type: {
            name: "String"
        }
    }
};
export var telephoneId0 = {
    parameterPath: "telephoneId",
    mapper: {
        required: true,
        serializedName: "telephoneId",
        type: {
            name: "String"
        }
    }
};
export var telephoneId1 = {
    parameterPath: "telephoneId",
    mapper: {
        required: true,
        serializedName: "telephoneId",
        type: {
            name: "Number"
        }
    }
};
export var termId = {
    parameterPath: "termId",
    mapper: {
        required: true,
        serializedName: "termId",
        type: {
            name: "String"
        }
    }
};
export var termsType = {
    parameterPath: [
        "options",
        "termsType"
    ],
    mapper: {
        serializedName: "termsType",
        type: {
            name: "String"
        }
    }
};
export var thumbnailQuality = {
    parameterPath: [
        "options",
        "thumbnailQuality"
    ],
    mapper: {
        serializedName: "thumbnailQuality",
        defaultValue: 90,
        type: {
            name: "Number"
        }
    }
};
export var thumbnailSize = {
    parameterPath: [
        "options",
        "thumbnailSize"
    ],
    mapper: {
        serializedName: "thumbnailSize",
        defaultValue: 1080,
        type: {
            name: "Number"
        }
    }
};
export var top0 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "top",
        defaultValue: 5,
        type: {
            name: "Number"
        }
    }
};
export var top1 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "top",
        defaultValue: 10,
        type: {
            name: "Number"
        }
    }
};
export var top2 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "top",
        defaultValue: 1,
        type: {
            name: "Number"
        }
    }
};
export var top3 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "top",
        type: {
            name: "Number"
        }
    }
};
export var top4 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "Top",
        type: {
            name: "Number"
        }
    }
};
export var type0 = {
    parameterPath: "type",
    mapper: {
        required: true,
        serializedName: "type",
        type: {
            name: "String"
        }
    }
};
export var type1 = {
    parameterPath: [
        "options",
        "type"
    ],
    mapper: {
        serializedName: "type",
        type: {
            name: "String"
        }
    }
};
export var typeCode = {
    parameterPath: [
        "options",
        "typeCode"
    ],
    mapper: {
        serializedName: "typeCode",
        type: {
            name: "String"
        }
    }
};
export var types = {
    parameterPath: [
        "options",
        "types"
    ],
    mapper: {
        serializedName: "Types",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var unionId = {
    parameterPath: "unionId",
    mapper: {
        required: true,
        serializedName: "unionId",
        type: {
            name: "String"
        }
    }
};
export var unpaidOnly = {
    parameterPath: [
        "options",
        "unpaidOnly"
    ],
    mapper: {
        serializedName: "unpaidOnly",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var userHash = {
    parameterPath: [
        "options",
        "userHash"
    ],
    mapper: {
        serializedName: "userHash",
        type: {
            name: "String"
        }
    }
};
export var voucherCode = {
    parameterPath: "voucherCode",
    mapper: {
        required: true,
        serializedName: "voucherCode",
        type: {
            name: "String"
        }
    }
};
export var wayBillNumber = {
    parameterPath: "wayBillNumber",
    mapper: {
        required: true,
        serializedName: "wayBillNumber",
        type: {
            name: "String"
        }
    }
};
export var width = {
    parameterPath: [
        "options",
        "width"
    ],
    mapper: {
        serializedName: "width",
        type: {
            name: "Number"
        }
    }
};
export var xClientApplication = {
    parameterPath: "xClientApplication",
    mapper: {
        required: true,
        serializedName: "X-Client-Application",
        type: {
            name: "String"
        }
    }
};
export var xMockResponse = {
    parameterPath: [
        "options",
        "xMockResponse"
    ],
    mapper: {
        serializedName: "x-mock-response",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var xNotificationCentreApiKey = {
    parameterPath: [
        "options",
        "xNotificationCentreApiKey"
    ],
    mapper: {
        serializedName: "X-NotificationCentre-ApiKey",
        type: {
            name: "String"
        }
    }
};
export var xTenantContext0 = {
    parameterPath: [
        "options",
        "xTenantContext"
    ],
    mapper: {
        serializedName: "x-tenant-context",
        type: {
            name: "String"
        }
    }
};
export var xTenantContext1 = {
    parameterPath: "xTenantContext",
    mapper: {
        required: true,
        serializedName: "x-tenant-context",
        type: {
            name: "String"
        }
    }
};
export var zipCode0 = {
    parameterPath: [
        "options",
        "zipCode"
    ],
    mapper: {
        serializedName: "zipCode",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var zipCode1 = {
    parameterPath: [
        "options",
        "zipCode"
    ],
    mapper: {
        serializedName: "ZipCode",
        type: {
            name: "String"
        }
    }
};

//# sourceMappingURL=parameters.js.map
